import adminApi from "services/admin-api";

export const workspaceReferenceService = {
  administrativeRegions: {
    create: adminApi.administrativeRegions.create,
    list: adminApi.administrativeRegions.list,
    remove: adminApi.administrativeRegions.remove,
    update: adminApi.administrativeRegions.update,
  },
  countries: {
    list: adminApi.countries.list,
  },
  sportAgeGroups: {
    create: adminApi.sportAgeGroups.create,
    list: adminApi.sportAgeGroups.list,
    remove: adminApi.sportAgeGroups.remove,
    update: adminApi.sportAgeGroups.update,
  },
  sports: {
    list: adminApi.sports.list,
  },
  teams: {
    list: adminApi.teams.list,
  },
};
